var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useRef, useState } from 'react';
export function useSelectableOptions(initial) {
    if (initial === void 0) { initial = []; }
    var initialRef = useRef(__spreadArray([], initial, true));
    var _a = useState(initial), selected = _a[0], setSelected = _a[1];
    var handleChange = useCallback(function (e) {
        var tempSelected = [];
        for (var i = 0; i < e.target.options.length; i++) {
            if (e.target.options[i].selected) {
                tempSelected.push(e.target.options[i].value);
            }
        }
        setSelected(tempSelected);
    }, []);
    var hasChanged = useCallback(function () {
        var prev = initialRef.current;
        return !(prev.length === selected.length &&
            prev.every(function (v, i) { return v === selected[i]; }));
    }, [selected]);
    return {
        selected: selected,
        handleChange: handleChange,
        hasChanged: hasChanged,
        setSelected: setSelected,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/hooks/useSelectableOptions.ts
// module id = 1566
// module chunks = 0